module.exports = __webpack_public_path__ + "static/img/mood14.ee72400.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moods/mood14.png
// module id = cwR5
// module chunks = 1